import { config } from '../../Config';

export const SaveMessageToCosmos = async (userDetails, userInputValue, serverMessage, chatId, citations, thinking = "", selectedModel = "") => {
    if (!userDetails) {
        // console.error("User not authenticated");
        return;
    }

    const messageData = {
        userId: userDetails.userId,
        chatId: chatId,
        userMessage: userInputValue,
        serverMessage: serverMessage,
        citations: citations || [],
        thinking: thinking || "",       
        selectedModel: selectedModel || "",
        timestamp: new Date().toISOString()
    };

    const url = config.createMessage;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(messageData)
        });

        if (!response.ok) {
            throw new Error(`Failed to save message to Cosmos DB: ${response.statusText}`);
        }

        // console.log('Message saved to Cosmos DB');
        const data = await response.json();
        return data.updatedChatTitle || null;
    } catch (error) {
        // console.error('Error saving message to Cosmos DB:', error);
        return null;
    }
};

export default SaveMessageToCosmos;
